import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { SearchContext } from '../Contexts';

const Facets = ({ facets, facetListIndex, mainValue }) => {
  const { facetsLists, setFacetsLists, selectedFacets, setSelectedFacets } =
    useContext(SearchContext);

  return (
    <div className="advanced-search__facet-dropdown">
      {facets.map((facet, index) => {
        const { label, value, selected, childrens } = facet;

        const addingFields = facetValue => {
          const selectedFacetsClone = { ...selectedFacets};
          if (mainValue in selectedFacets) {
            // adding the values after the first time
            selectedFacetsClone[mainValue].push(facetValue);
          } else {
            // adding the value for the first time
            Object.assign(selectedFacetsClone, { [mainValue]: [facetValue] });
          }
          setSelectedFacets(selectedFacetsClone);
        };

        const removingFields = facetValue => {
          const selectedFacetsClone = { ...selectedFacets};
          // clearing value from existing on the array
          if (
            selectedFacetsClone[mainValue] && selectedFacetsClone[mainValue].length &&
            selectedFacetsClone[mainValue].includes(facetValue)
          ) {
            selectedFacetsClone[mainValue].splice(
              selectedFacetsClone[mainValue].indexOf(facetValue), 1
            );
          }
          setSelectedFacets(selectedFacetsClone);
        };

        const resetChildrens = () => {
          if (childrens && childrens.length)
            childrens.forEach(child => {
              child.selected = false;
              removingFields(child.value);
            });
        };

        const handleCheck = () => {
          const facetsListsClone = [...facetsLists];
          facetsListsClone[facetListIndex].facets[index].selected =
            !facetsListsClone[facetListIndex].facets[index].selected;
          setFacetsLists(facetsListsClone);

          if (!facetsListsClone[facetListIndex].facets[index].selected) {
            resetChildrens();
          }

          if (facetsListsClone[facetListIndex].facets[index].selected) {
            addingFields(value);
          } else if (
            selectedFacets[mainValue] &&
            selectedFacets[mainValue].length
          ) {
            removingFields(value);
          }
        };

        return (
          <div key={index} className="advanced-search__facet">
            <input
              type="checkbox"
              name={value}
              value={value}
              checked={selected}
              readOnly
            />
            <label htmlFor={value} onClick={() => handleCheck()}>
              {label}
            </label>
            {selected && childrens && childrens.length ? (
              <div className="advanced-search__subFacet-container">
                {childrens.map((subfacet, i) => {
                  const handleSubCheck = () => {
                    const facetsListsClone = [...facetsLists];
                    facetsListsClone[facetListIndex].facets[index].childrens[
                      i
                    ].selected =
                      !facetsListsClone[facetListIndex].facets[index].childrens[
                        i
                      ].selected;
                    setFacetsLists(facetsListsClone);

                    if (
                      facetsListsClone[facetListIndex].facets[index].selected
                    ) {
                      if (
                        facetsListsClone[facetListIndex].facets[index]
                          .childrens[i].selected
                      ) {
                        addingFields(subfacet.value);
                      } else if (
                        selectedFacets[mainValue] &&
                        selectedFacets[mainValue].length
                      ) {
                        removingFields(subfacet.value);
                      }
                    }
                  };
                  return (
                    <div
                      key={i}
                      className="advanced-search__facet"
                      onClick={() => handleSubCheck()}
                    >
                      <input
                        type="checkbox"
                        name={subfacet.value}
                        value={subfacet.value}
                        checked={subfacet.selected}
                        readOnly
                      />
                      <label htmlFor={subfacet.value}>{subfacet.label}</label>
                    </div>
                  );
                })}
              </div>
            ) : (
              ''
            )}
          </div>
        );
      })}
    </div>
  );
};

Facets.propTypes = {
  facets: PropTypes.array.isRequired,
  facetListIndex: PropTypes.number.isRequired,
  mainValue: PropTypes.string.isRequired
};

export default Facets;
